export default __webpack_public_path__ + "static/media/6.031c3f90.png";